exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-39f1b9a6] {\n  font-size: 14px;\n}\n@media (min-width: 1200px) {\n.container[data-v-39f1b9a6] > > > {\n    max-width: 1140px !important;\n}\n}\ni.large.icon[data-v-39f1b9a6], i.large.icons[data-v-39f1b9a6] {\n  font-size: 1rem;\n}\n.container[data-v-39f1b9a6] > > > {\n  padding: 7.5px;\n}\na[data-v-39f1b9a6] {\n  text-decoration: none !important;\n}", ""]);

// exports
